
import { computed, defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// @components
import NewButton from '@/ui-kit/NewButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

import AdditionalServicesBlock from '@/modules/NewDispatcher/components/AdditionalServicesBlock/index.vue'

// @types
import { WaveInvoice } from '@/new-services/types/waves'
import { InvoiceT } from '@/core/types/orders.types'

// @realisations
import { orders } from '@/core/realisations/orders.realisation'

// @composable
import useNotifications from '@/common/composable/useNotifications'
import { useMaska } from '@/common/composable/useMaska'
import useAccount from '@/common/composable/useAccount'

// @validation
import useVuelidate from '@vuelidate/core'
import { required, decimal, integer } from '@vuelidate/validators'

// @constants
import { PHONE_NUMBER_MASK } from '@/core/constants/masks.constants'

export default defineComponent({
    components: {
        NewButton,
        Loader,
        TheInput,
        AdditionalServicesBlock,
    },
    props: {
        invoice: {
            type: Object as PropType<WaveInvoice>,
            required: true,
        },
        isUpdateLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()
        const { unmaskNumbers } = useMaska()
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            invoice: null as InvoiceT | null,
        })

        const form = reactive({
            places: null as string | null,
            weight: null as string | null,
            volumeWeight: null as string | null,
            fullAddress: null as string | null,
            title: null as string | null,
            phone: null as string | null,
            additional_phone: null as string | null,
            fullName: null as string | null,
            direction: null as string | null,
            manager: null as string | null,
        })

        const form$ = useVuelidate(
            {
                places: { required, integer },
                weight: { required, decimal },
                volumeWeight: { required, decimal },
                fullAddress: { required },
                title: { required },
                phone: { required },
                additional_phone: { required },
                fullName: { required },
                direction: { required },
                manager: { required },
            },
            form
        )

        const fillInfo = (data: InvoiceT) => {
            if (!data) return

            state.invoice = data

            form.places = data.places.toString()
            form.weight = data.weight.toString()
            form.volumeWeight = data.volume_weight.toString()
            form.fullAddress = data.receiver.full_address
            form.title = data.receiver.title
            form.phone = data.receiver.phone
            form.additional_phone = data.receiver.additional_phone
            form.fullName = data.receiver.full_name
            form.direction = data.direction
            state.invoice.delivery_date = data.delivery_date

            if (data.manager) {
                form.manager = data.manager.email
            }
        }

        const loadInvoice = async () => {
            try {
                state.is_loading = true

                const response = await orders.getInvoice(props.invoice.id)
                fillInfo(response.data)

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении данных накладной произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadInvoice)

        // const onUpdate = () => {
        //     if (props.isUpdateLoading || !state.invoice) return

        //     form$.value.$touch()
        //     if (form$.value.$invalid) return

        //     const payload: UpdateCargoPayload = {
        //         places: Number(form.places as string),
        //         weight: Number(form.weight as string),
        //         volumeWeight: Number(form.volumeWeight as string),
        //         fullAddress: form.fullAddress as string,
        //         title: form.title as string,
        //         phone: unmaskNumbers(form.phone as string),
        //         additional_phone: unmaskNumbers(form.additional_phone as string),
        //         fullName: form.fullName as string,
        //     }

        //     emit('update', { invoice_id: state.invoice.id, payload })
        // }

        const emitCancel = () => {
            if (props.isUpdateLoading) return
            emit('cancel')
        }

        // computed

        const isCanUpdate = computed(() =>
            havePermissions(['order-logistics-info-update-cargo-data', 'all-root-permission'])
        )

        const isCanShowSenderServices = computed(() => {
            if (
                !state.invoice ||
                !state.invoice.order_additional_services_values ||
                !state.invoice.order_additional_services_values.length
            )
                return false
            return true
        })

        const isCanShowReceiverServices = computed(() => {
            if (
                !state.invoice ||
                !state.invoice.additional_services_values ||
                !state.invoice.additional_services_values.length
            )
                return false
            return true
        })

        //

        return {
            PHONE_NUMBER_MASK,
            //
            state,
            form,
            form$,
            //
            loadInvoice,
            emitCancel,
            isCanUpdate,
            isCanShowSenderServices,
            isCanShowReceiverServices,
        }
    },
})
